import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

var jwtDecode = require('jwt-decode');

export function loginSuccess(user) {
  return {
    type: types.LOGIN_SUCCESS,
    currentUser: user,
  };
}

export function logoutSuccess() {
  return { type: types.LOGOUT_SUCCESS };
}

export function logIn(credentials) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'auth/login';
    return axios
      .post(url, {
        usernameOrEmail: credentials.username,
        password: credentials.password,
      })
      .then((response) => {
        localStorage.setItem('accessToken', response.data.accessToken);
        let tokenData = Object.assign({}, jwtDecode(response.data.accessToken));
        let user = {
          id: tokenData.sub,
          initials: tokenData.initials,
          resetRequired: tokenData.resetRequired,
          roles: tokenData.scopes,
        };
        localStorage.setItem('user', JSON.stringify(user));
        dispatch(loginSuccess(user));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function logOut() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'auth/logout';
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return axios
      .get(url)
      .then(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        dispatch(logoutSuccess());
      })
      .catch((error) => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function changePassword(oldPass, newPass) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'auth/change-password';
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return axios
      .post(url, {
        oldPassword: oldPass,
        newPassword: newPass,
      })
      .then(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        dispatch(logoutSuccess());
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js